import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Modal, Typography } from "@mui/material";

import CancelFigure from "../../assets/images/cancel-alert.png";

import { useCancelModal } from "./useCancelModal";

export const CancelModal = ({
  open,
  closeModal,
  handelCancel,
  title,
  subTitle,
}: {
  open: boolean;
  closeModal: () => void;
  handelCancel: () => void;
  title: string;
  subTitle?: string;
}) => {
  const { t } = useTranslation("goService", { keyPrefix: "cancelModal" });

  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={styles.container}>
        <Box sx={styles.contentContainer}>
          <Box component="img" src={CancelFigure} alt="cancel-figure" sx={styles.figure} />
          <Box sx={styles.content}>
            <Typography sx={styles.title}>{title}</Typography>
            {subTitle && <Typography sx={styles.subTitle}>{subTitle}</Typography>}
          </Box>
          <Divider flexItem orientation="horizontal" sx={styles.divider} />
          <Box sx={styles.buttonsContainer}>
            <Button onClick={closeModal} variant="outlined-md">
              {t("no")}
            </Button>
            <Button onClick={handelCancel} variant="primary-md">
              {t("yes")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export { useCancelModal };

const styles = {
  container: {
    width: "800px",
    height: "fit-content",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "16px",
    background: "#FFF",
    boxShadow: "0px 4px 50px 0px rgba(0, 0, 0, 0.08), 0px 4px 6px 0px rgba(0, 0, 0, 0.05)",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    padding: "24px 32px",
  },
  figure: {
    width: "80px",
    height: "80px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
  subTitle: {
    color: "var(--Dark---800, #414141)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  buttonsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px",
  },
  divider: {
    mx: "-32px",
  },
};
